import { Button, Notice } from "@smooth/design-system-components"
import dayjs from "dayjs"
import { useState } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"

/** MCI 実査用 CSV を作ってダウンロードする。内容・形式・ファイル名は受け取る側が前提にしているので変えない */
export const MciFactoringInspectionCsv = () => {
  const { getWithToken } = useSmoothApi()
  const [isCreating, setIsCreating] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const handleCreate = async () => {
    setIsCreating(true)
    setErrorMessage(null)
    try {
      const response = await getWithToken(`${SMOOTH_SMOOTHER_API_URL}/screen/mci_factoring_inspection`, {
        responseType: "blob",
      })
      const filename = `mci_factoring_inspection_create${dayjs().format("YYYYMMDD")}.csv`
      const url = URL.createObjectURL(response.data as Blob)
      const link = document.createElement("a")
      link.href = url
      link.download = filename
      link.click()
      URL.revokeObjectURL(url)
    } catch {
      setErrorMessage("CSV の作成に失敗しました")
    } finally {
      setIsCreating(false)
    }
  }

  return (
    <div className="flex flex-col gap-4">
      {errorMessage && (
        <Notice tone="error" variant="card">
          {errorMessage}
        </Notice>
      )}
      <div>
        <Button variant="outline" disabled={isCreating} onClick={handleCreate}>
          {isCreating ? "作成中..." : "MCI実査用のCSVデータを作成する"}
        </Button>
      </div>
    </div>
  )
}
